import { render, staticRenderFns } from "./IdentityValidationTwoSteps.vue?vue&type=template&id=05a371da&"
import script from "./IdentityValidationTwoSteps.vue?vue&type=script&lang=js&"
export * from "./IdentityValidationTwoSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports